angular.module('eStories.end-cap-deal.compnt', [])


    .component('endCapDeal', {
        transclude: true,
        bindings: {
            data: '<',
            title: '<'
        },

        /*data is only valid for grid-carousel*/
        controller: 'EndCapDealCtrl',
        controllerAs: 'endCapDealCtrl',
        templateUrl: 'components/end-cap-deal/end-cap-deal.tmpl.html'
    })

    .controller('EndCapDealCtrl', ['$filter', '$rootScope', 'AccountModel',
        function ($filter, $rootScope, AccountModel) {
            this.playSample = audiobook => {
                $rootScope.$broadcast('playSample', audiobook);
            };

            this.getProductPricesText = audiobook => {
                return AccountModel.getMyPrice(audiobook, true, AccountModel.hasSubscription());
            };

            this.showPurchaseModal = () => {
                AccountModel.showPurchaseAudiobookModal(this.data[0].audiobook, 'RETAIL')
            };

            this.getStaticEndCapBg = function (backgroundUrl) {
                const url = $filter('imageByWidth')(backgroundUrl, 1920);
                return {
                    background: 'url(' + url + ') center center no-repeat'
                }
            };
        }]);